/** In-app notifications (v2.2 Phase 18). */
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "./client";

export interface AppNotification {
  id: string;
  kind: string;
  title: string;
  body: string;
  data: Record<string, unknown>;
  read: boolean;
  created_at: string;
}

export interface NotificationList {
  items: AppNotification[];
  unread: number;
}

const KEY = ["notifications"];

export function useNotifications(enabled = true) {
  return useQuery({
    queryKey: KEY,
    queryFn: async (): Promise<NotificationList> => {
      const { data } = await api.get<NotificationList>("/notifications");
      return data;
    },
    enabled,
    refetchInterval: 60_000, // light poll so the bell badge stays roughly fresh
  });
}

export function useMarkNotificationRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string): Promise<void> => {
      await api.post(`/notifications/${id}/read`, {});
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

export function useMarkAllNotificationsRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (): Promise<void> => {
      await api.post("/notifications/read-all", {});
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}
